import { ReactElement } from 'react';
import { RouteObject } from 'react-router-dom';

import { CLIENT_MATTER_ROUTES } from '@/routes/clientMatterRoutes';

/**
 * Creates a client matter route configuration with the specified path pattern and element.
 * This factory function eliminates duplication between the two client matter URL patterns:
 * - /:clientMatterId (new pattern)
 * - /:clientNumber/:matterNumber (legacy pattern)
 *
 * @param pathPattern - The base path pattern (e.g., '/:clientMatterId' or '/:clientNumber/:matterNumber')
 * @param element - The React element to render for this route
 * @returns Complete route configuration with all client matter child routes
 */
export function createClientMatterRoute(pathPattern: string, element: ReactElement): RouteObject {
  return {
    path: pathPattern,
    element,
    children: CLIENT_MATTER_ROUTES,
  };
}
